import * as yup from "yup";

import {
    REQUIRED_FIELD_BOOLEAN,
    REQUIRED_FIELD_TEXT
} from "../LinkRegistryConstants";

import { LinkAction } from "../../../models";
import { LinkRegistryFormOutput } from "./LinkRegistryFormOutput";
import { externalReportLinkRegistryVariablesSchema } from "./variables/ExternalReportLinkRegistryVariablesSchema";

export const linkRegistryFormSchema: yup.SchemaOf<LinkRegistryFormOutput> = yup.object({
    linkAction: yup.mixed<LinkAction>().oneOf(Object.values(LinkAction)).required(REQUIRED_FIELD_TEXT),
    variables: yup.object()
        .when("linkAction", {
            is: LinkAction.EXTERNAL_REPORT,
            then: yup.object()
                .when("isPublished", {
                    is: true,
                    then: externalReportLinkRegistryVariablesSchema
                })
        })
        .when("linkAction", {
            is: LinkAction.ASSESSMENT_FORM,
            then: yup.object()
                .when("isPublished", {
                    is: true,
                    then: externalReportLinkRegistryVariablesSchema
                })
        })
        .when("linkAction", {
            is: LinkAction.ISSUE_FORM,
            then: yup.object({
                propertyId: yup.string().required(REQUIRED_FIELD_TEXT),
                locationId: yup.string()
            })
        })
        .when("linkAction", {
            is: LinkAction.CUSTOM_LINK,
            then: yup.object({
                url: yup.string().required(REQUIRED_FIELD_TEXT).url("Must be a valid URL")
            })
        })
        .when("linkAction", {
            is: LinkAction.UNASSIGNED,
            then: yup.object({})
        })
        .default(yup.object({})),
    isPublished: yup.boolean().required(REQUIRED_FIELD_BOOLEAN)
});